<template>
    <v-card
        class="mt-10 mx-auto"
        >
        <v-sheet
            class="v-sheet--offset mx-auto"
            color="indigo"
            elevation="12"
            max-width="calc(100% - 32px)"
        >
        <!-- {{labels}} -->
        <!-- {{value}} -->
            <v-sparkline
            :labels="labels"
            :value="value"
            color="white"
            line-width="3"
            padding="16"
            auto-draw
            ></v-sparkline>
        </v-sheet>
    
        <v-card-text class="pt-0">
            <div class="font-weight-bold mb-2">{{title}}</div>
            <div 
                v-for="n in subheading"
                :key="n"
                class="subheading font-weight-light grey--text">{{n}}
            </div>
            <div
                v-for="n in progressBar"
                :key="n.text"
                class='d-flex pt-1'
                >
                <v-flex  xs6 sm6 md4 lg4 xl2>
                    <span>{{n.text}}</span>
                </v-flex>
                <v-flex  xs6 sm6 md8 lg8 xl10>
                    <v-progress-linear
                        v-model="n.value"
                        height="25"
                        reactive
                        >
                        <strong>{{  (n.value) ? n.value.toFixed(2) : 0 }}%</strong>
                    </v-progress-linear>
                </v-flex>
            </div>
            <v-divider class="my-2"></v-divider>
            <v-card-actions class="d-flex justify-space-around ma-0 pa-0">
                <v-flex>
                    <v-icon class="mr-2" small>mdi-clock</v-icon>
                    <span class="caption grey--text font-weight-light">{{caption}}</span>
                </v-flex>

                <v-btn v-if="id" :to="{ name: 'automationsCampaigns', params: { id }}" fab dark x-small color="indigo">
                    <v-icon dark>add</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'Sparkline',
    props: ['id','title','subheading', 'progressBar','icon','caption','labels', 'value'],
}
</script>

<style>
    .v-sheet--offset {
        top: -24px;
        position: relative;
    }
</style>